// extracted by mini-css-extract-plugin
module.exports = {"upsell-button":"upsell-button__upsell-button___1GNUl"};